import triggerAnalyticsEvent from './triggerAnalyticsEvent'

const analyticsMapIconClick = () => {
  triggerAnalyticsEvent('mapIconSelected')
}

export default analyticsMapIconClick
